import React, {Component} from 'react';

export class StaticText extends Component {
  render() {
    return <p style={{"margin-bottom":'10px'}} > {this.props.value}</p>;
  }
}
